import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FunctionsService, HttpService,LocalStorageService, MenuBreadCrumb, MessageService, SessionService } from 'brainloper-ui';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { NotificationsService } from 'src/app/services/notifications.service';
import { WorkOrderService } from 'src/app/services/work-order.service';
import { IRegisterMaintenance } from 'src/app/models/maintenance/register-maintenance';
import { GeneratePdfFosilService } from 'src/app/services/generate-pdf-fosil.service';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { HistoricalWO } from 'src/app/models/maintenance/historicalWO';
import { GenericResponse } from 'src/app/models/commos/generic-response';

@Component({
    selector: 'app-maintenance-register',
    templateUrl: './maintenance-register.component.html',
    styleUrls: ['./maintenance-register.component.scss'],
    standalone: false
})
export class MaintenanceRegisterComponent implements OnInit {


  private urlEjecturarOT: string = `${EndpointDictionary.WorkOrder.WORK_ORDER_CLOSE}`
  private id_orden: number

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Registro Mtto",
      current: true
    }
  ]

  constructor(
    private http: HttpService,
    private session: SessionService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private router: Router,
    public dialog: MatDialog,
    public notificationService: NotificationsService,
    private storage: LocalStorageService,
    public workOrderService: WorkOrderService,
    private generatePdf: GeneratePdfFosilService,

  ) {
    this.session.setData('data', { action: 'add' })
  }

  async ngOnInit() {
  }


  async registerMaintenance($event: IRegisterMaintenance) {
    this.message.openLoading('Cargando', 'Registrando mantenimiento')
    try {
      const responsiblesIds = $event.responsible.map(item => Number(item.id));
      let workOrder: WorkOrder = await this.saveOT($event.workOrder, $event.maintenanceType, $event.activityId, responsiblesIds, $event.responsibleType)
      this.message.closeLoading()
      this.message.SuccessToast(`Orden de trabajo creada`)
      this.router.navigate(['/inicio'])
      if ($event.print) {
        await  this.generatePdf.printTemplateOt(workOrder.id, true)
      }

    } catch (error) {
      this.message.Error("Error", "Error registrando mantenimiento")
    }
  }

  async saveOT(data: WorkOrder, maintenanceType: string, activityId:number,responsiblesIds?: number[], responsibleType?:string) : Promise<WorkOrder> {
    //form to save work orders
    let form: WorkOrder = {
      ...data,
      executionDate: this.functionEter.dateForm(data.executionDate),
      creatorId: this.storage.get<number>('userId'),
      active: 1,
      authorized: 1,
      activityId: 0,
      readyResources: 1
    }

    form.responsiblesBody = {
      responsiblesIds,
      responsibleType: responsibleType,
      sendNotification: false,      
    }

    this.id_orden = await this.workOrderService.addWO(form, maintenanceType, activityId)
    if (this.id_orden > 0) {
      form.id = this.id_orden
      let form2: HistoricalWO = {
        workOrderId: this.id_orden,
        finalCost: data.cost,
        finalTime: data.estimatedTime,
        observations: '',
      }
      let resEjecucionOT: GenericResponse = await this.http.postDataBody(`${this.urlEjecturarOT}`, form2)

      if (!resEjecucionOT) {
        this.message.Error('Error', resEjecucionOT['message'])
      }
    }
    return form
  }

}
